import {
  Action,
  ActionType,
  IFullStressLastNotificationTimeResponse,
} from "models/stressCheck/fullStressLastNotificationTime";
import createReducer from "redux/createReducer";

export interface FullStressLastNotificationTimeReducerType {
  loading: boolean;
  error?: string;
  fullStressLastSendNotificationTimeResponse?: IFullStressLastNotificationTimeResponse;
}

const defaultState: FullStressLastNotificationTimeReducerType = {
  loading: false,
  error: undefined,
  fullStressLastSendNotificationTimeResponse: undefined,
};

export const fullStressLastNotificationTimeReducer =
  createReducer<FullStressLastNotificationTimeReducerType>(defaultState, {
    [ActionType.FULL_STRESS_LAST_NOTIFICATION_TIME](
      state: FullStressLastNotificationTimeReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.FULL_STRESS_LAST_NOTIFICATION_TIME_ERROR](
      state: FullStressLastNotificationTimeReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
        fullStressLastSendNotificationTimeResponse: undefined,
      };
    },

    [ActionType.FULL_STRESS_LAST_NOTIFICATION_TIME_SUCCESS](
      state: FullStressLastNotificationTimeReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        fullStressLastSendNotificationTimeResponse: action.payload,
      };
    },

    [ActionType.FULL_STRESS_LAST_NOTIFICATION_TIME_RESET](
      state: FullStressLastNotificationTimeReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        fullStressLastSendNotificationTimeResponse: undefined,
      };
    },
  });
